import React from 'react';
import liff from '@line/liff';

const BRAND_ORANGE = '#FF6B35';

const COMMANDS = [
  {
    category: 'รายจ่าย',
    icon: '💸',
    color: '#fff4f0',
    items: [
      { cmd: 'จำรายจ่าย', title: 'บันทึกรายจ่าย', desc: 'พิมพ์แล้วบอกรายการ เช่น "ค่าข้าว 50, กาแฟ 65"' },
      { cmd: 'ดูรายจ่าย', title: 'ดูรายจ่ายย้อนหลัง', desc: 'เลือกเดือนแล้วดูรายการทั้งหมด' },
      { cmd: 'สรุปรายจ่าย', title: 'สรุปยอดรวม', desc: 'ยอดรวมรายจ่ายแยกตามเดือน' },
    ],
  },
  {
    category: 'ที่จอดรถ',
    icon: '🅿️',
    color: '#f0f7ff',
    items: [
      { cmd: 'จอด 4B', title: 'จำที่จอดรถ', desc: 'เปลี่ยนเลขชั้นได้ตามจริง เช่น "จอด 2D"' },
      { cmd: 'จอดรถชั้นไหน', title: 'ดูที่จอดที่บันทึกไว้', desc: 'บอตจะตอบชั้นที่จำไว้ล่าสุด' },
    ],
  },
  {
    category: 'บอลโลก 2026',
    icon: '⚽',
    color: '#f0fff5',
    items: [
      { cmd: 'ผลบอล', title: 'ผลบอลล่าสุด', desc: 'ดูผลการแข่งขันย้อนหลัง 48 ชั่วโมง' },
      { cmd: 'บอลโลกวันนี้', title: 'โปรแกรมวันนี้', desc: 'ดูตารางแข่งวันนี้ถึง 08:00 น. ของวันถัดไป' },
      { cmd: 'ทีม อังกฤษ', title: 'ค้นหาข้อมูลทีม', desc: 'ดูผลและโปรแกรมของทีม เปลี่ยนชื่อทีมได้เลย' },
      { cmd: 'รับแจ้งเตือนบอลโลก', title: 'สมัครรับแจ้งเตือน', desc: 'รับผลบอลและโปรแกรมทุกเช้า' },
      { cmd: 'ยกเลิกแจ้งเตือนบอลโลก', title: 'ยกเลิกการแจ้งเตือน', desc: 'หยุดรับการแจ้งเตือนบอลโลก' },
    ],
  },
  {
    category: 'บัญชี',
    icon: '🔗',
    color: '#f0fff5',
    items: [
      { cmd: 'เชื่อมบัญชี', title: 'เชื่อมต่อ LINE กับระบบ', desc: 'ต้องทำก่อนใช้งานฟีเจอร์รายจ่าย' },
    ],
  },
];

const HelpPage = () => {
  const handleClose = () => {
    try { liff.closeWindow(); } catch { window.history.back(); }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7f8fa', paddingBottom: 40 }}>
      <div style={{ backgroundColor: BRAND_ORANGE, padding: '20px 16px 16px', position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ margin: 0, fontSize: 10, color: 'rgba(255,255,255,0.75)', fontWeight: 700, letterSpacing: '0.8px' }}>
              MEMMANY BOT
            </p>
            <h1 style={{ margin: '2px 0 0', fontSize: 20, fontWeight: 700, color: '#fff' }}>คู่มือการใช้งาน</h1>
            <p style={{ margin: '2px 0 0', fontSize: 11, color: 'rgba(255,255,255,0.8)' }}>ปลาทองช่วยจำ</p>
          </div>
          <button
            onClick={handleClose}
            style={{ backgroundColor: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 20, padding: '8px 16px', color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}
          >
            ปิด
          </button>
        </div>
      </div>

      <div style={{ padding: 16 }}>
        {COMMANDS.map(({ category, icon, color, items }) => (
          <div key={category} style={{ backgroundColor: '#fff', borderRadius: 14, overflow: 'hidden', marginBottom: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', borderBottom: '0.5px solid #f0f0f0' }}>
              <div style={{ width: 30, height: 30, borderRadius: 8, backgroundColor: color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
                {icon}
              </div>
              <span style={{ fontSize: 14, fontWeight: 700, color: '#111' }}>{category}</span>
            </div>
            {items.map(({ cmd, title, desc }, i) => (
              <div
                key={cmd}
                style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 16px', borderBottom: i < items.length - 1 ? '0.5px solid #f7f7f7' : 'none', backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}
              >
                <span style={{ fontSize: 12, fontWeight: 700, color: BRAND_ORANGE, backgroundColor: '#fff4f0', borderRadius: 6, padding: '3px 9px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                  {cmd}
                </span>
                <div style={{ flex: 1 }}>
                  <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: '#111' }}>{title}</p>
                  <p style={{ margin: '2px 0 0', fontSize: 11, color: '#888', lineHeight: 1.4 }}>{desc}</p>
                </div>
              </div>
            ))}
          </div>
        ))}

        <div style={{ backgroundColor: '#fff8f5', borderRadius: 14, padding: '14px 16px', marginTop: 4 }}>
          <p style={{ margin: 0, fontSize: 12, color: '#888', textAlign: 'center', lineHeight: 1.6 }}>
            พิมพ์คำสั่งในแชทกับบอตได้เลย<br />
            หรือพิมพ์ <span style={{ fontWeight: 700, color: BRAND_ORANGE }}>ช่วยด้วย</span> เพื่อเรียกการ์ดนี้อีกครั้ง
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
